import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import { CompareProvider } from "./context/CompareContext";
import { ThemeProvider } from "./context/ThemeContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import About from "./pages/About";
import WhereToBuy from "./pages/WhereToBuy";
import Contact from "./pages/Contact";
import Wishlist from "./pages/Wishlist";
import Compare from "./pages/Compare";
import ProductImport from "./pages/ProductImport";
import AdminInventory from "./pages/AdminInventory";
import InventoryBulkUpdate from "./pages/InventoryBulkUpdate";
import AdminOrders from "./pages/AdminOrders";
import AdminNewsletter from "./pages/AdminNewsletter";
import AdminCoupons from "./pages/AdminCoupons";
import AdminPush from "./pages/AdminPush";
import BikeFinder from "./pages/BikeFinder";
import AdminBikeCompatibility from "./pages/AdminBikeCompatibility";
import LoginPage from "./pages/LoginPage";
import AuthCallback from "./pages/AuthCallback";
import CustomerDashboard from "./pages/CustomerDashboard";
import { AuthProvider } from "./context/AuthContext";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import ScrollToTop from "./components/ScrollToTop";
import CleanTrackingParams from "./components/CleanTrackingParams";
import PromoBanner from "./components/PromoBanner";
import InstallPWAPrompt from "./components/InstallPWAPrompt";
import PushOptInPrompt from "./components/PushOptInPrompt";
import { useLocation } from "react-router-dom";

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id (Google OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <CleanTrackingParams />
      <PromoBanner />
      <Header />
      <div style={{ paddingTop: 'var(--promo-h, 0px)' }}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:sku" element={<ProductDetail />} />
        <Route path="/trova-ricambi-per-moto" element={<BikeFinder />} />
        <Route path="/find-parts-by-bike" element={<BikeFinder />} />
        <Route path="/buscar-recambios-por-moto" element={<BikeFinder />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/about" element={<About />} />
        <Route path="/where-to-buy" element={<WhereToBuy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin/import" element={<ProductImport />} />
        <Route path="/admin/inventory" element={<AdminInventory />} />
        <Route path="/admin/inventory-bulk" element={<InventoryBulkUpdate />} />
        <Route path="/admin/orders" element={<AdminOrders />} />
        <Route path="/admin/newsletter" element={<AdminNewsletter />} />
        <Route path="/admin/coupons" element={<AdminCoupons />} />
        <Route path="/admin/push" element={<AdminPush />} />
        <Route path="/admin/bike-compatibility" element={<AdminBikeCompatibility />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/account" element={<CustomerDashboard />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      </Routes>
      </div>
      <Footer />
      <InstallPWAPrompt />
      <PushOptInPrompt />
      <BackToTop />
      <WhatsAppButton />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#1a1a1a',
            color: '#ffffff',
            border: '1px solid rgba(255, 102, 0, 0.3)',
          },
          className: 'toast-slide',
        }}
        visibleToasts={3}
        closeButton
      />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
    <div className="App" style={{ overflowX: 'hidden', maxWidth: '100vw', position: 'relative' }}>
      <ThemeProvider>
        <LanguageProvider>
          <CartProvider>
            <WishlistProvider>
              <CompareProvider>
                <AuthProvider>
                <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          </AuthProvider>
        </CompareProvider>
      </WishlistProvider>
    </CartProvider>
  </LanguageProvider>
  </ThemeProvider>
</div>
</HelmetProvider>
  );
}

export default App;
